module.exports = __webpack_public_path__ + "img/1871233843174039.34be37ef.jpg";